import { consola } from 'consola'

export default defineNuxtPlugin((nuxtApp) => {
  const logger = consola.create({
    formatOptions:
        {
          date: false,
          columns: 2,
        },
  })

  nuxtApp.hook('vue:error', (error) => {
    const sanitizedError = {
      message: error instanceof Error ? error.message : String(error),
      stack: error instanceof Error ? error.stack : undefined,
      name: error instanceof Error ? error.name : 'UnknownError',
    }

    logger.box({
      title: 'Vue Error',
      message: 'An error occurred in a Vue component',
      level: 'error',
      data: sanitizedError,
    })
  })

  nuxtApp.hook('app:error', (error) => {
    const sanitizedError = {
      message: error instanceof Error ? error.message : String(error),
      stack: error instanceof Error ? error.stack : undefined,
      name: error instanceof Error ? error.name : 'UnknownError',
    }

    logger.box({
      title: 'App Error',
      message: 'An error occurred in a Vue component',
      level: 'error',
      data: sanitizedError,
    })
  })
  nuxtApp.vueApp.config.errorHandler = (..._args) => {
    // if (process.client) {
    //   console.log(..._args)
    // }
  }
})
